import React from "react";

import IconBase, { IconBaseProps } from "./IconBase";

/**
 * Lipid — 20×20 lab group icon (Figma 835:62).
 * Test-tube + accents, 5 vector layers.
 */
const IconLipid: React.FC<IconBaseProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 24;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 20 20"
      {...props}
    >
      <g transform="translate(1.666 1.666)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.89254 0L0 5.89257L3.24092 9.13344L9.13346 3.2409L5.89254 0ZM5.339 1.8127L4.74975 2.40195L6.81212 4.46436L7.40137 3.87511L5.339 1.8127ZM3.86587 3.2859L3.27662 3.87515L5.339 5.93752L5.92825 5.34827L3.86587 3.2859ZM2.39252 4.75898L1.80327 5.34823L3.86567 7.41061L4.45492 6.82136L2.39252 4.75898Z"
        />
      </g>
      <g transform="translate(4.944 4.952)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.71404L4.71404 0L12.0798 7.36571C13.3815 8.66746 13.3815 10.778 12.0798 12.0797C10.778 13.3815 8.66746 13.3815 7.36571 12.0797L0 4.71404ZM1.1785 4.71404L7.95496 11.4905C8.93125 12.4668 10.5142 12.4668 11.4905 11.4905C12.4668 10.5142 12.4668 8.93129 11.4905 7.95496L4.71404 1.17854L1.1785 4.71404Z"
        />
      </g>
      <g transform="translate(8.184 6.72)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 3.24088L3.24092 0L8.24958 5.00867L5.00867 8.24954L0 3.24088ZM1.1785 3.24088L5.00867 7.07104L7.07104 5.00867L3.24092 1.1785L1.1785 3.24088Z"
        />
      </g>
      <g transform="translate(9.804 11.73)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.47312 0.736333C1.47325 0.736333 1.47304 0.736374 1.47312 0.736333C0.883917 1.031 0.147333 1.76754 0 2.20946L2.79896 5.0085C3.938 6.1475 5.78471 6.1475 6.92375 5.00846C8.06275 3.86946 8.06279 2.02271 6.92375 0.883708L6.04004 0L3.38858 2.65142L1.47312 0.736333Z"
        />
      </g>
      <g transform="translate(9.362 11.14)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.952208 2.71979L3.53592 5.30304C4.51221 6.27933 6.09513 6.27933 7.07146 5.30304C8.04775 4.32671 8.04775 2.74383 7.07146 1.7675L6.482 1.1785L3.83067 3.82983L1.84921 1.84862C1.66946 1.97096 1.47942 2.12958 1.30746 2.30154C1.15296 2.45604 1.03346 2.60092 0.952208 2.71979ZM0.718208 1.71229C1.01483 1.41562 1.382 1.12629 1.72875 0.952916L1.77862 0.928L2.05225 0.873125L3.83067 2.65133L6.482 0L7.66071 1.17825C8.96246 2.48 8.96246 4.59054 7.66071 5.89229C6.35896 7.19404 4.24842 7.19404 2.94667 5.89229L0 2.94608L0.0347916 2.70258L0.0466665 2.66696C0.152333 2.35004 0.431958 1.99854 0.718208 1.71229Z"
        />
      </g>
    </IconBase>
  );
};

export default IconLipid;
